<template>
  <div id="app">
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
@import "./styles/element_base.scss";
@import "./styles/base.scss";

#app {
  width: 100%;
  background-color: #fff;
}
a{
	color: #333333;
	text-decoration: none;
}
</style>
